import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import config from '../config';

class useTrackerGoogle extends React.Component {
  constructor(props) {
    super(props);
    ReactGA.initialize(config.googleAnalytics);
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
    this.props.history.listen((location) => {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
      });
    });
  }

  render() {
    return null;
  }
}

const GlobalHistory = withRouter(useTrackerGoogle);

export default GlobalHistory;
